import config from './';

type DomainTokenMapping = {
  domains: string[];
  token: string;
};

const parseDomainTokenMapping = (value?: string): Array<DomainTokenMapping> => {
  if (!value?.trim()) {
    return [];
  }

  try {
    return JSON.parse(value);
  } catch {
    return [];
  }
};

const domaiTokenMapping: Array<DomainTokenMapping> = parseDomainTokenMapping(
  config.system_user_token,
);

export default domaiTokenMapping;
